import { action } from 'satcheljs';

export let onSelectFolderComplete = action(
    'ON_SELECT_FOLDER_COMPLETE',
    (selectedFolderId: string) => ({
        selectedFolderId,
    })
);

export let onSingleMailItemSelected = action('ON_SINGLE_MAIL_ITEM_SELECT');
